// Strip Czech diacritics and lowercase for string matching
export function cleanString(str: string): string {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

// Note: Maps Czech/English DB category names and model filenames to simplified English item types
// used by the LLM and Python executor ("sofa", "chair", "table", "cabinet", "bed", "door", "window", "lighting", "decoration").
// Once category UUIDs in the external DB are stable or have explicit English tags, we can replace this with a direct ID map.
export function classifyTypeFromCategoryName(categoryName: string | undefined, objectName: string): string {
  const cleanObj = cleanString(objectName);
  if (cleanObj.includes('okn') || cleanObj.includes('window')) return 'window';
  if (cleanObj.includes('dver') || cleanObj.includes('door')) return 'door';
  if (cleanObj.includes('postel') || cleanObj.includes('luzk') || cleanObj.includes('bed')) return 'bed';

  if (categoryName) {
    const cleanCat = cleanString(categoryName);

    // Check Czech category names from the database (normalized)
    if (cleanCat.includes('postel') || cleanCat.includes('luzk') || cleanCat.includes('matrac') || cleanCat.includes('valend') || cleanCat.includes('paland') || cleanCat.includes('kolib') || cleanCat.includes('bed')) return 'bed';
    if (cleanCat.includes('pohov') || cleanCat.includes('sedac') || cleanCat.includes('kresl')) return 'sofa';
    if (cleanCat.includes('zidl') || cleanCat.includes('kreslo') || cleanCat.includes('taburet') || cleanCat.includes('lavic')) return 'chair';
    if (cleanCat.includes('stol') || cleanCat.includes('stul')) return 'table';
    if (cleanCat.includes('komod') || cleanCat.includes('skrin') || cleanCat.includes('ulozn') || cleanCat.includes('knihovn') || cleanCat.includes('regal') || cleanCat.includes('vitrin') || cleanCat.includes('sestav') || cleanCat.includes('sten')) return 'cabinet';
    if (cleanCat.includes('dver')) return 'door';
    if (cleanCat.includes('okn')) return 'window';
    if (cleanCat.includes('svit') || cleanCat.includes('svetl') || cleanCat.includes('lamp') || cleanCat.includes('osvetl')) return 'lighting';
    if (cleanCat.includes('dekor')) return 'decoration';
  }

  // Fallback classification by object name (English or general matching)
  const lower = objectName.toLowerCase();
  const cleanLower = cleanString(objectName);
  if (cleanLower.includes('bed') || cleanLower.includes('postel') || cleanLower.includes('luzk') || cleanLower.includes('matrac') || cleanLower.includes('valend') || cleanLower.includes('paland') || cleanLower.includes('kolib')) return 'bed';
  if (lower.includes('chair') || lower.includes('kreslo') || lower.includes('zidle') || lower.includes('stolicka')) return 'chair';
  if (lower.includes('sofa') || lower.includes('gauci') || lower.includes('sedacka')) return 'sofa';
  if (lower.includes('desk') || lower.includes('psaci') || lower.includes('stul') || lower.includes('stol')) return 'table';
  if (lower.includes('cabinet') || lower.includes('komoda') || lower.includes('skrin') || lower.includes('knihovna')) return 'cabinet';
  if (lower.includes('door') || lower.includes('dvere')) return 'door';
  if (lower.includes('window') || lower.includes('okno')) return 'window';
  if (lower.includes('light') || lower.includes('lampa') || lower.includes('osvetleni') || lower.includes('ceilinglight')) return 'lighting';
  return 'decoration';
}
